import { Sutl } from '../../../../sutl';
export class Observable {
    constructor(idPrefix = '') {
        this.idPrefix = idPrefix;
        this.id = 0;
        this.listeners = [];
    }
    get numListeners() {
        return this.listeners.length;
    }
    notifyListeners(value) {
        this.listeners.forEach(listener => listener.callback(value));
    }
    subscribe(callback, end = true) {
        const listener = {
            id: this.idPrefix + (this.id++).toString(),
            callback,
        };
        if (end) {
            this.listeners.push(listener);
        }
        else {
            this.listeners.unshift(listener);
        }
        return listener.id;
    }
    unsubscribe(id) {
        Sutl.filterInPlace(this.listeners, (listener) => {
            return listener.id !== id;
        });
    }
    unsubscribeAll() {
        this.listeners.length = 0;
    }
}
export class ObservableCollection {
    constructor(idPrefix = '') {
        this.idPrefix = idPrefix;
        this.id = 0;
        this.listeners = [];
    }
    get numListeners() {
        return this.listeners.length;
    }
    notifyListeners(key, value) {
        this.listeners.forEach(listener => listener.callback(key, value));
    }
    subscribe(callback, end = true) {
        const listener = {
            id: this.idPrefix + (this.id++).toString(),
            callback,
        };
        if (end) {
            this.listeners.push(listener);
        }
        else {
            this.listeners.unshift(listener);
        }
        return listener.id;
    }
    unsubscribe(id) {
        Sutl.filterInPlace(this.listeners, (listener) => {
            return listener.id !== id;
        });
    }
    unsubscribeAll() {
        this.listeners.length = 0;
    }
}
